<template>
    <div>
        <div class="RDSMonitor-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.databaseId}}</BreadcrumbItem>
                <BreadcrumbItem to="/monitor/relationalDatabaseServiceMonitor">{{ $t('alarms.database.database') }}</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.alertRule') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.common.alertRule')">
                    <div class="RDSMonitor-top">
                        <relational-database-service-warning-search></relational-database-service-warning-search>
                    </div>
                    <table-relational-database-service-warning></table-relational-database-service-warning>
                </TabPane>
            </Tabs>
        </template>
    </div>
</template>

<script>
    import RelationalDatabaseServiceWarningSearch from '../rds/RelationalDatabaseServiceWarningSearch'
    import TableRelationalDatabaseServiceWarning from '../rds/TableRelationalDatabaseServiceWarning'

    export default {
        name: 'RelationalDatabaseServiceMonitor',
        components: {
            RelationalDatabaseServiceWarningSearch,
            TableRelationalDatabaseServiceWarning
        },
        data(){
            return {
            }
        },
        methods:{
            // 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.databaseId=this.$route.query.databaseId;
                this.region=this.$route.query.region;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.engine=this.$route.query.engine;
                this.$router.push({path:'/monitor/relationalDatabaseServiceDetail/',query: {id: this.id,accountId:this.accountId,databaseId:this.databaseId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name,engine:this.engine}});
            }
        }
    }
</script>

<style scoped>
    .RDSMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .RDSMonitor-title>div:nth-child(1)
    {
        float:left;
    }
    .RDSMonitor-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .RDSMonitor-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/rds/RelationalDatabaseServiceWarning.vue